import { OtpAwcResponse } from '@absis/core-plugins/src/types/core-plugins-types';
import { OTPPlugin } from '@absis/core-plugins';

export const CBOTP: OTPPlugin = {
  getOTP: (): Promise<OtpAwcResponse> => {
    return Promise.reject({
      code: 'OTP999',
      message: 'CBOTP is not supported for Desktop devices',
    });
  },
};
